// Common file utilities for names, extensions, and type checks

export const getFileExtension = (fileName: string): string => {
  if (!fileName) return '';
  const dot = fileName.lastIndexOf('.');
  return dot >= 0 ? fileName.substring(dot + 1) : '';
};

export const truncateFileName = (name: string, max: number = 20): string => {
  if (!name) return '';
  if (name.length <= max) return name;
  return `${name.substring(0, max)}...`;
};

export const isImageFileName = (pathOrName?: string | null): boolean => {
  if (!pathOrName) return false;
  return /\.(jpg|jpeg|png|gif|webp)$/i.test(pathOrName);
};


